export default {
  id: 'tn-syos-focus-outline-square',
  path: 'M4 14v54h54V14zm4 4h46v46H8z',
};
